<template>
  <div class="grid-x grid-padding-x small-up-1 medium-up-2 large-up-2">
    <div 
      v-for="(location, index) in locations"
      :key="index"
      class="cell">
      <address class="boxx">
        <strong>{{ location.title }}</strong><br />
        {{ location.address }}<br />
        {{ location.city }}, {{ location.state }}<br />
        Phone: {{ location.phone }}
      </address>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Locations',
  props: {
    locations: {
      type: Array
    }
  }
}
</script>
